import type { StateTree } from 'pinia'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { createPinia } from 'pinia'
import { PersistenceOptions } from 'pinia-plugin-persistedstate'

declare module 'pinia' {
    // eslint-disable-next-line unused-imports/no-unused-vars
    export interface DefineStoreOptionsBase<S extends StateTree, Store> {
        persist?: boolean | PersistenceOptions<S> | PersistenceOptions<S>[]
    }
}

export * from 'pinia'

export const createPiniaWithSentryMiddleware = () => {
    const pinia = createPinia()
    pinia.use(createSentryPiniaPlugin({
        stateTransformer: (state) => {
            // Transform the state to remove sensitive information
            const transformedState = {
                ...state,
                user: 'hidden',
            }
            if (Object.hasOwn(transformedState, 'qr-code')) {
                // @ts-expect-error no need to types here
                transformedState['qr-code'] = {
                    // @ts-expect-error no need to types here
                    ...transformedState['qr-code'],
                    token: '---',
                }
            }
            return transformedState
        },
    }))
    return pinia
}
